module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "MultipleChoice"
  }, [_c('img', {
    staticClass: "MultipleChoice-image",
    attrs: {
      "src": _vm.content.image
    }
  }), _vm._v(" "), (_vm.content.text) ? _c('p', {
    staticClass: "MultipleChoice-question",
    domProps: {
      "innerHTML": _vm._s(_vm.replaceName(_vm.content.text))
    }
  }) : _vm._e(), _vm._v(" "), (_vm.content.options) ? _c('div', {
    staticClass: "MultipleChoice-options"
  }, _vm._l((_vm.content.options), function(option, index) {
    return _c('button-component', {
      key: index,
      staticClass: "MultipleChoice-option",
      nativeOn: {
        "click": function($event) {
          _vm.submit($event)
        }
      }
    }, [_vm._v("\n      " + _vm._s(option.label) + "\n    ")])
  })) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-205057d6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Learn/MultipleChoice.vue
// module id = 800
// module chunks = 1